{
  "backgroundType": "gradient",
  "plainBackgroundMode": "daylight",
  "gradientColors": "#EE7752, #E73C7E, #23A6D5, #23D5AB",
  "FirstName": "Apoorv",
  "MiddleName": "",
  "LastName": "Verma",
  "devDesc": "| Engineer | Programmer | Developer | Designer | Gamer ",
  "icons": [
    {
      "id": 0,
      "image": "fa-github",
      "url": "https://github.com/apoorvverma",
      "label": "GitHub profile"
    },
    {
      "id": 1,
      "image": "fa-facebook",
      "url": "https://www.facebook.com/apoorv.verma.33633",
      "label": "Facebook profile"
    },
    {
      "id": 2,
      "image": "fa-instagram",
      "url": "https://www.instagram.com/verma.apoorv/",
      "label": "Instagram profile"
    },
    {
      "id": 3,
      "image": "fa-linkedin",
      "url": "https://www.linkedin.com/in/apoorv1999verma/",
      "label": "LinkedIn profile"
    },
    {
      "id": 4,
      "image": "fa-twitter",
      "url": "https://www.twitter.com/1999apoorv/",
      "label": "Twitter profile"
    }
  ],
  "aboutHeading": "About Me",
  "aboutDescription": "A Curious Guy pursuing Computer Science Engineering from Shri Vaishnav Vidyapeeth Vishwavidyalaya - Indore, India. Having 2+ years of experience as a student member in Microsoft Campus Club, SVVV & currently the Student Co-ordinator of This Club!",
  "projectHeading": "Recent Projects",
  "gitHubLink": "https://api.github.com/users/",
  "gitHubUsername": "apoorvverma",
  "gitHubQuerry": "/repos?sort=updated&direction=desc",
  "projectsLength": 4,
  "showNavigationbar": true,
  "showBlog": false
}
